
import env from "env";
import { io } from "socket.io-client";

let socket = null;

// In socket.ts - UPDATE the initializeSocket function
export const initializeSocket = () => {
  if (socket && socket.connected) {
    console.log("✅ Socket already connected:", socket.id);
    return socket;
  }

  const sessionId = localStorage.getItem("sessionId");
  const backendUrl = process.env.REACT_APP_WS_URL || env.apiLink;
  const newToken = localStorage.getItem('accessToken')

  console.log("🔄 Initializing socket with sessionId:", sessionId);

  if (!sessionId) {
    console.warn("❌ No sessionId found for socket connection");
    return null;
  }

  socket = io(backendUrl, {
    auth: { token: newToken },
    transports: ["websocket", "polling"],
    autoConnect: true,
    timeout: 10000, // Increase timeout
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
  });

  socket.emit('auth:update', newToken)

  socket.on("connect", () => {
    console.log("✅ Socket connected successfully, ID:", socket.id);
  });

  socket.on("connect_error", (err) => {
    console.error("❌ Socket connection error:", err.message);
  });

  socket.on("disconnect", (reason) => {
    console.log("🔌 Socket disconnected:", reason);
  });

  return socket;
};
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => socket;
